const {
  Mixin,
  strategies: {
    sync: { override },
  },
} = require('@xingternal/hops');

const { HttpLink } = require('@apollo/client');
const {
  InMemoryCache,
  defaultDataIdFromObject,
} = require('@apollo/client/cache');
const possibleTypes = require('./fragmentTypes.json');

class GraphQLMixin extends Mixin {
  getApolloLink() {
    return new HttpLink({
      uri: this.config.graphqlUri,
      fetch: this.fetch,
      headers: {
        'XING-ONE-PREVIEW': true,
      },
    });
  }

  getApolloCache() {
    const cache = new InMemoryCache({
      dataIdFromObject: (object) =>
        object.globalId || defaultDataIdFromObject(object),
      possibleTypes,
    });

    if (typeof window === 'undefined') {
      return cache;
    }
    return cache.restore(global.APOLLO_STATE);
  }
}

GraphQLMixin.strategies = {
  getApolloLink: override,
};

module.exports = GraphQLMixin;
